import React, { Component } from 'react';
import './Maintenance.css';

class Maintenance extends Component {
    render() {
        return (
            <div className="maintenance">
                Ce site est en maintenance, il sera de nouveau disponible prochainement <br />
                Merci de votre comprehension
            </div>
        );
    }
}

export default Maintenance;



// WEBPACK FOOTER //
// ./src/components/Maintenance.js